package api


/*

UPDATE PORTAL.CAMPAIGN
SET STATE = 64
WHERE STATE = 3;

UPDATE PORTAL.CAMPAIGN
SET STATE = 32
WHERE STATE = 2;

UPDATE PORTAL.CAMPAIGN
SET STATE = 8
WHERE STATE = 1;

UPDATE PORTAL.CAMPAIGN
SET STATE = 2
WHERE STATE = 0;

UPDATE PORTAL.CAMPAIGN
SET STATE = 4
WHERE STATE = 8 and date(now()) < date(DT_START);

UPDATE PORTAL.CAMPAIGN
SET STATE = 16
WHERE STATE = 8 and date(now()) > date(DT_END);
 */
sealed class CampaignState(var state: Int, val label: String) {

    /** DRAFT: 2*/
    data object DRAFT : CampaignState(2, "Draft")

    /** PUBLISHED: 4*/
    data object PUBLISHED : CampaignState(4, "Published")

    /** ACTIVE: 8*/
    data object ACTIVE : CampaignState(8, "Active")

    /** FINISHED: 16*/
    data object FINISHED : CampaignState(16, "Finished")

    /** STOPPED: 32*/
    data object STOPPED : CampaignState(32, "Stopped")

    /** Deleted: 64*/
    data object DELETED : CampaignState(64, "Deleted")

    /** Deleted: 128*/
    data object PAUSED : CampaignState(128, "Paused")

    infix fun match(state: Int): Boolean = this.state and state > 0

    companion object {
        val all by lazy {
            arrayOf(DRAFT, ACTIVE, PUBLISHED, PAUSED, FINISHED, STOPPED, DELETED)
        }

        operator fun get(state: Int): CampaignState {
            return all.firstOrNull { it match state } ?: DRAFT
        }
    }
}
